import { defineComponent as _defineComponent } from 'vue'
import {
	withDefaults,
	ref,
	Ref,
	computed,
	ComputedRef,
	onMounted,
} from "vue";

// Store
import store from "@/vue/planning/store/store";

// Components
import PrestationPictureMobile from "@/vue/planning/components/result/prestation/pictureMobile.vue";
import LimitedAvailabilityMessage from "@/vue/planning/components/result/prestation/limitedAvailabilityMessage.vue";
import InfoIcons from "@/vue/planning/components/result/infoIcons.vue";
import PlaceholderBox from "@/vue/planning/components/common/placeholderBox.vue";
import Inclus from "@/vue/planning/components/result/prestation/inclus.vue";
import PackageDetalisPopUp from "@/vue/planning/components/result/prestation/packageDetalisPopUp.vue";

// Logic
import { isPierreVacance } from "@/vue/planning/logic/pv";
import { isCS } from "@/vue/planning/logic/cs";
import { isValidNewSkiPassPackages } from "@/vue/planning/logic/isValidNewSkiPassPackages";

// Types
import { Prestation } from "@/types";

interface Props {
	prestation: Prestation;
	isDisplayPlaceholders: boolean;
}
interface Emits {
	(e: "plusInfosClick"): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'detailsTop',
  props: {
    prestation: { default: {} },
    isDisplayPlaceholders: { type: Boolean, default: false }
  },
  emits: ["plusInfosClick"],
  setup(__props: any, { emit }: { emit: ({
	(e: "plusInfosClick"): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { prestation: Prestation, isDisplayPlaceholders: boolean };




// computed
const reference = computed(() => {
	const variants = props.prestation.variants;
	if (!variants) return;

	if (variants[0]["pvFlex"]) {
		const nonFlexVariant = variants.find((prest: any) => {
			return prest.pvFlex === "nonflex";
		});

		return nonFlexVariant.prestIdSource;
	}

	return variants[0].prestIdSource;
});

const isHSProduct = computed(() => {
	return props.prestation.variants[0].codePackage === "HS";
});

const lowestQuantity = computed(() => {
	const variants = props.prestation.variants;
	if (!variants) return;
	variants.sort((a: any, b: any) => a.quantity - b.quantity);
	return variants[0].quantity;
});


const image: ComputedRef<string> = computed(() => {
	const images = props.prestation?.picturesAccomodation || [];
	if (images.length === 0) return "";

	const img = images[0];
	return (
		img["imgSmall"] ||
		img["imgMedium"] ||
		img["imgLarge"] ||
		img["imgXL"] ||
		img["img"] ||
		""
	);
});


// methods
const handlePlusDinfosClick = () => {
	emit("plusInfosClick");
};

/**
 * Determines if the stay is considered short based on specific conditions.
 *
 * This function checks if the first variant meets the CS condition 
 * (i.e., if it is not a CS variant or if it is a CS variant and is Pierre Vacance).
 * It also checks if the ski pass conditions for the new ski pass pacakges are valid.
 *
 * @returns {boolean} True if both the CS condition and the ski pass condition are met, indicating a short stay, false otherwise.
 */
const isShortStay=():boolean=> {
	const variants = props.prestation.variants;
	const firstVariant = variants[0];

	const CScondition = (!isCS(firstVariant) || (isCS(firstVariant) && isPierreVacance(firstVariant)))
	const skiPassCondition = !isValidNewSkiPassPackages(variants)

	return (CScondition && skiPassCondition);
}


return { __sfc: true,props, emit, reference, isHSProduct, lowestQuantity, image, handlePlusDinfosClick, isShortStay, store, PrestationPictureMobile, LimitedAvailabilityMessage, InfoIcons, PlaceholderBox, Inclus, PackageDetalisPopUp, isPierreVacance }
}

})